// extracted by mini-css-extract-plugin
export default {"activityArea":"index_activityArea_UUWD2","activityList":"index_activityList_0fT9U"};